<template>
  <generic-modal
    :title="$t('loan application')"
    ref="generic_modal"
    :is_wide="true"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("applicant name") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.applicant_name"
                :class="{ 'is-danger': !meta.applicant_name }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("applicant email") }}</label>
            <div class="control">
              <input
                type="email"
                class="input"
                v-model="meta.applicant_email"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("applicant phone") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.applicant_phone" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("applicant document") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.applicant_document"
                :class="{ 'is-danger': !meta.applicant_document }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label"
              >{{ $t("requested amount") }}
              <span class="has-text-danger">*</span></label
            >
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.requested_amount"
                step="0.01"
                :class="{ 'is-danger': !meta.requested_amount }"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("monthly income") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.monthly_income"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('loan type')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/loan/loan-type/catalog"
              name_field="name"
              value_field="loan_type_id"
              @selected="set_loan_type"
              ref="loan_type_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("credit score") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.credit_score"
                min="300"
                max="850"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("purpose") }}</label>
        <div class="control">
          <textarea class="textarea" v-model="meta.purpose" rows="3"></textarea>
        </div>
      </div>

      <div class="columns" v-if="application_uuid">
        <!-- <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('status')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              :options="status_options"
              name_field="label"
              value_field="value"
              @selected="set_status"
              ref="status_dropdown"
            />
          </div>
        </div> -->
        <div class="column" v-if="meta.status === 'approved'">
          <div class="field">
            <label class="label">{{ $t("approved amount") }}</label>
            <div class="control">
              <input
                type="number"
                class="input"
                v-model="meta.approved_amount"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="field"
        v-if="
          application_uuid &&
          (meta.status === 'approved' || meta.status === 'rejected')
        "
      >
        <label class="label">{{ $t("review notes") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.review_notes"
            rows="2"
          ></textarea>
        </div>
      </div>
    </form>

    <div class="notification is-danger" v-if="error" v-html="error"></div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { generate_error_message_text, del, post, put, get } from "@/utils";

export default {
  name: "ApplicationModal",
  components: { GenericModal, GenericDropdown },
  data() {
    let v = this;
    return {
      meta: {},
      error: "",
      application_uuid: "",
      status_options: [
        { value: "pending", label: v.$t("pending") },
        { value: "under_review", label: v.$t("under review") },
        { value: "approved", label: v.$t("approved") },
        { value: "rejected", label: v.$t("rejected") },
        { value: "cancelled", label: v.$t("cancelled") },
      ],
    };
  },
  computed: {
    is_form_invalid() {
      return (
        !this.meta.applicant_name ||
        !this.meta.applicant_document ||
        !this.meta.requested_amount ||
        !this.meta.loan_type_id
      );
    },
  },
  methods: {
    show_modal(uuid = null) {
      let v = this;
      v.application_uuid = uuid;
      v.$refs.generic_modal.show_modal();
      if (uuid) {
        v.get_application(uuid);
      }
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      if (v.is_form_invalid) return;

      let data = { ...v.meta };

      if (v.application_uuid) {
        data.uuid = v.application_uuid;
        post("/loan/application", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/loan/application", data)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    get_application(uuid) {
      let v = this;
      get("/loan/application", { uuid: uuid })
        .then((response) => {
          v.meta = response;
          if (v.meta.loan_type_id && v.$refs.loan_type_dropdown) {
            v.$refs.loan_type_dropdown.set_value(v.meta.loan_type_id);
          }
          if (v.meta.status && v.$refs.status_dropdown) {
            v.$refs.status_dropdown.set_value(v.meta.status);
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      v.application_uuid = "";
      v.$refs.loan_type_dropdown.clear();
      if (v.$refs.status_dropdown) {
        v.$refs.status_dropdown.clear();
      }
    },
    set_loan_type(loan_type) {
      let v = this;
      if (loan_type) v.meta.loan_type_id = loan_type.loan_type_id;
    },
    set_status(status) {
      let v = this;
      if (status) v.meta.status = status.value;
    },
  },
  watch: {},
};
</script>
